module.exports = __webpack_public_path__ + "res/13-img_game_selected.0c1105f5b7001355f1f7959629d4ba1e.webp";